import { message } from 'antd';
import { useTranslate } from '@tolgee/react';
import { platformUploadImageAcceptMap, platformUploadSizeLimitMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';

const UPLOAD_MAX_COUNT = 3;

type TranslateFn = ReturnType<typeof useTranslate>['t'];

export const getFileExtension = (name: string) => {
  const lastDot = name.lastIndexOf('.');
  return lastDot === -1 ? '' : name.slice(lastDot + 1).toLowerCase();
};

export const getAttachmentMaxCount = (channel: General.PlatformUpperCaseTunnel) =>
  channel === 'JOLECT' ? 1 : UPLOAD_MAX_COUNT;

/**
 * 附件上传前校验：数量上限、大小限制、Jolect 扩展名白名单。
 * 校验失败时提示并返回 false。
 */
export const validateAttachmentFile = (
  channel: General.PlatformUpperCaseTunnel,
  file: File,
  currentAttachmentCount: number,
  t: TranslateFn,
) => {
  const channelKey = toLowerCase(channel);
  const uploadSizeLimit = platformUploadSizeLimitMap[channelKey];
  const maxCount = getAttachmentMaxCount(channel);

  if (currentAttachmentCount >= maxCount) {
    message.warn(
      t('scene.chatWorkspace.messageEditor.upload.validation.maxAttachmentCount', {
        count: maxCount,
      }),
    );
    return false;
  }
  if (file.size > uploadSizeLimit) {
    message.warn(
      t('upload.limitWarn', {
        size: `${(uploadSizeLimit / 1024 / 1024).toFixed(2)}M`,
      }),
    );
    return false;
  }
  if (channel === 'JOLECT') {
    const allowedExtensions = platformUploadImageAcceptMap[channelKey];
    if (!allowedExtensions.includes(getFileExtension(file.name))) {
      message.warn(
        t('upload.fileLimit', {
          size: `${(uploadSizeLimit / 1024 / 1024).toFixed(2)}`,
          type: allowedExtensions.join(', '),
        }),
      );
      return false;
    }
  }

  return true;
};
